import { ActionButton, Image, View, SimpleText, Text, XStack, YStack, LinearGradient } from '@my/ui'
import { color, getImageColorStyle } from '@my/util'

interface HomeMainHeadingProps {
  type?: string
  displayNative?: any
  image?: any
  //footerImage?: any
  onPress?: any
  welcome: React.ReactElement
}

const whiteFilter = getImageColorStyle(color.white);

export const HomeMainHeading: React.FC<HomeMainHeadingProps> = ({
  type,
  image,
  displayNative = 'none',
  welcome,
  onPress,
}) => {
  // Styles for the gradient wrapper
  const gradientStyle = {
    width: 51,
    height: 51,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 100,
  }

  // Styles for the image inside the gradient
  const imageStyle = {
    width: 25,
    height: 25,
    ...whiteFilter
  };

  return (
    <XStack padding="$4" alignItems={'center'} justifyContent="space-between" style={{width: '100%'}}>
      <YStack gap={10} style={{width: '100%'}}>
        <XStack 
          gap={10} 
          style={{width: '100%', justifyContent: 'flex-start', alignItems: 'center'}} 
          //$platform-native={{ display: displayNative }}
        >
          <LinearGradient
            colors={
              ['rgb(130, 196, 154)', 'rgb(130, 196, 154)']
              //['#85C19D', '#63995D']
            }
            start={[0, 0.3]}
            end={[0, 0]}
            style={gradientStyle}
          >
            <Image resizeMode="contain" tintColor={color.white} src={image} style={imageStyle} />
          </LinearGradient>

          {/* <Text fontSize={18} ta="center" fontWeight="700" color={color.grey}>
            {type}
          </Text> */}
          <SimpleText
                    color={color.darkNavy}
                    fontWeight="700"
            $platform-native={{ fontSize: 30 }}
            $platform-web={{ fontSize: 30 }}
          >
            Welcome to Parity!
          </SimpleText>
        </XStack>
        {welcome}
      </YStack>
      
    </XStack>
  )
}
